import { reactQueryGet } from "@circle-react/helpers/backendRequestHelpers";
import { internalApi } from "@circle-react/helpers/urlHelpers";

export type BillingProduct = "admin" | "headless" | "ai_actions";

export interface BillingCycle {
  admin?: { limit: number };
  ai_actions?: { limit: number };
  end_date: number;
  headless?: { limit: number };
  id: string;
  start_date: number;
}

export interface BillingCyclesResponse {
  billing_cycles: BillingCycle[];
}

interface FetchBillingCyclesOptions {
  limit?: number;
  products?: BillingProduct[];
}

const fetchBillingCycles = (
  options: FetchBillingCyclesOptions = {},
): Promise<BillingCyclesResponse> =>
  reactQueryGet<BillingCyclesResponse>(
    internalApi.AccountSubscriptions.getBillingCycles(
      options.limit,
      options.products,
    ),
  );

export const billingCyclesApi = {
  fetchBillingCycles,
};
